<template>
  <div class="feeall">
    <van-nav-bar
        title="用气详情"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />

    <div class="margin0"/>

    <van-cell v-model="C_Code" icon="user-circle-o" size="large" >
      <!-- 使用 title 插槽来自定义标题 -->
      <template #title>
        <span class="custom-title">{{C_Name}}</span>
      </template>
    </van-cell>
    <van-cell  icon="wap-home-o">
      <template #title>
        <span class="custom-title2">{{C_Address}}</span>
      </template>
    </van-cell>

    <div class="margin1"/>

    <van-cell-group >
      <van-cell  v-model="FA_NDate" icon="calendar-o" size="large">
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <span class="custom-title">抄表日期  </span>
          <van-tag v-if="FA_Flag === '销账'" type="success">{{FA_Flag}}</van-tag>
          <van-tag v-if="FA_Flag === '欠费'" type="danger">{{FA_Flag}}</van-tag>
          <van-tag v-if="FA_Flag === '扣费途中'" type="warning">{{FA_Flag}}</van-tag>
          <van-tag v-if="FA_Flag === '微信扣费中'" type="warning">{{FA_Flag}}</van-tag>
        </template>
      </van-cell>
      <van-cell title="用气量" v-model="FA_Count" icon="bar-chart-o"/>
      <van-cell title="总气费" v-model="FA_Fee" icon="gold-coin-o"/>
      <van-cell title="违约金" v-model="FA_Fee" icon="refund-o"/>
      <van-cell title="已缴气费" v-model="FA_Fee" icon="balance-pay"/>
      <van-divider>用气详情</van-divider>
      <van-cell title="表号" v-model="FL_MeterCode"/>
      <van-cell title="上期读数" v-model="FL_LCount"/>
      <van-cell title="本期读数" v-model="FL_NCount"/>
    </van-cell-group>


  </div>
</template>
<script>
//import { Toast } from 'vant';
import API from './../api/index';
export default {
  name: 'page_feeall',
  data() {
    return {
      C_ID:"",
      C_Code:"",
      C_Name:"",
      C_Address:"",
      list: [],
      FA_NDate:"",
      FA_Flag:"",
      FA_Fee:"",
      FA_LateFee:"",
      FA_Pay:"",
      FA_Count:"",
      FL_MeterCode:"",
      FL_LCount:"",
      FL_NCount:"",
      FL_OldEst:"",
      index:""
    };
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1);
    },
    setMessage() {
      this.C_ID=this.$cookie.get('CID');
      this.C_Code=this.$cookie.get('C_Code');
      this.C_Address=this.$cookie.get('CAddress');
      this.C_Name=this.$cookie.get('CName');
      let index =this.$cookie.get('fa_index');
      this.$http.get(API.LookFeeAllByWX,{
        params: {
          c_id:this.C_ID
        }
      })
          .then((response)=>{
            let res = response.data;
            if (res.code == 0) {
              this.FA_NDate=res.subdata[index].FA_NDate;
              this.FA_Flag=res.subdata[index].FA_Flag;
              this.FA_Fee=res.subdata[index].FA_Fee + ' 元';
              this.FA_LateFee=res.subdata[index].FA_LateFee + ' 元';
              this.FA_Pay=res.subdata[index].FA_Pay + ' 元';
              this.FA_Count=res.subdata[index].FA_Count + ' 立方';
              this.FL_MeterCode=res.subdata[index].FL_MeterCode;
              this.FL_LCount=res.subdata[index].FL_LCount;
              this.FL_NCount=res.subdata[index].FL_NCount;
              this.FL_OldEst=res.subdata[index].FL_OldEst;
            }
          });
    }
  },
  mounted () {
    this.setMessage();
  }
}
</script>
<style>
.index{
  height: 100vh;
  background-color: #f5f5f5;
}
.margin1{
  height: 0.5rem;
  background-color: #f5f5f5;
}
.margin0{
  height: 0.5rem;
  background-color: #f5f5f5;
}

</style>